export default "__VITE_ASSET__5a346ee0__"